import { bindFinishTourOnClick, unbindFinishTourOnClick } from '../../tourUi'

const FORM_READY_SELECTOR = '[data-tour="cliente-form-root"][data-carregado="true"]'

const openOpcionais = () => {
    const details = document.querySelector('[data-tour="cliente-opcionais"]')
    if (details) details.open = true
}

const hasClientesNaLista = () => document.querySelectorAll('[data-tour="cliente-lista"] tbody tr').length > 0

let handoffEditarClienteHandler = null

const bindHandoffAoEditarCliente = (tourManager) => {
    if (handoffEditarClienteHandler) return

    handoffEditarClienteHandler = (event) => {
        if (event.target.closest('input[type="checkbox"]')) return

        setTimeout(() => {
            if (!/\/cliente\/\d+\/editar/.test(window.location.pathname)) return
            if (tourManager.activeTourName !== 'novo-cliente') return

            unbindHandoffAoEditarCliente()
            tourManager.handoff('novo-cliente', 'editar-cliente', FORM_READY_SELECTOR)
        }, 100)
    }

    document.addEventListener('click', handoffEditarClienteHandler, true)
}

const unbindHandoffAoEditarCliente = () => {
    if (!handoffEditarClienteHandler) return

    document.removeEventListener('click', handoffEditarClienteHandler, true)
    handoffEditarClienteHandler = null
}

const mostrarAviso = (message, options = {}) => {
    document.dispatchEvent(new CustomEvent('showAviso', {
        detail: {
            message,
            callback: options.callback ?? null,
            callbackClose: options.callbackClose ?? null,
            callbackLabelClose: options.callbackLabelClose ?? 'Fechar',
            callbackLabel: options.callbackLabel ?? 'Continuar',
        },
    }))
}

const isFormularioPreenchido = () => {
    const root = document.querySelector('[data-tour="cliente-form-root"]')
    return root?.getAttribute('data-form-preenchido') === 'true'
}

const AVISO_SALVAR_CLIENTE = 'Os dados preenchidos durante o tour serão <b>salvos</b> como um novo cliente.'

const salvarCliente = () => {
    document.querySelector('[data-tour="cliente-salvar"]')?.click()
}

const aguardarAvisoDeSucesso = (tourManager) =>
    tourManager.waitForElement(() => {
        const body = document.querySelector('.modal.show .modal-body')

        if (body && /sucesso/i.test(body.textContent || '')) return body

        return null
    }, 8000)

const bindIrParaMonitoradoLink = (tourManager) => {
    setTimeout(() => {
        const link = document.querySelector(
            '.driver-popover-description [data-hdv-ir-monitorado]'
        )

        if (!link || link._hdvIrMonitoradoBound) return

        link._hdvIrMonitoradoBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            tourManager.finish('cliente-pos-salvar')
            tourManager.history?.push('/monitorado')
        })
    }, 0)
}

const buildClientePosSalvarTourSteps = (tourManager) => [
    {
        popover: {
            title: 'Tudo pronto!',
            description: 'O cliente foi salvo com sucesso. Agora você pode <a href="#" class="hdv-tour-start-link" data-hdv-ir-monitorado>vincular este cliente a um Monitorado</a>.',
            onDoneClick: () => tourManager.finish('cliente-pos-salvar'),
        },
        onHighlighted: () => bindIrParaMonitoradoLink(tourManager),
    },
]

const salvarClienteEMostrarProximosPassos = (tourManager) => {
    salvarCliente()

    aguardarAvisoDeSucesso(tourManager)
        .then(() => {
            document.querySelector('.modal.show .modal-footer .hdv-btn-blue')?.click()

            return tourManager.waitForElement('[data-tour="cliente-lista"]')
        })
        .then(() => {
            tourManager.start('cliente-pos-salvar', { resumeIndex: 0 })
        })
        .catch(() => {})
}

const concluirTour = (tourManager) => () => {
    tourManager.finish('novo-cliente')

    if (!isFormularioPreenchido()) return

    mostrarAviso(AVISO_SALVAR_CLIENTE, {
        callback: () => salvarClienteEMostrarProximosPassos(tourManager),
        callbackLabelClose: 'Cancelar',
    })
}

const irParaPerfilCliente = (tourManager) => {
    tourManager.navigateAndWait('/perfil/cliente', '[data-tour="help-perfil-cliente-grid"]', 0)
        .then(() => {
            tourManager.handoff(
                'novo-cliente',
                'novo-perfil-cliente',
                '[data-tour="help-perfil-cliente-grid"]'
            )
        })
        .catch(() => {})
}

const bindIrPerfilClienteLink = (tourManager) => {
    setTimeout(() => {
        const link = document.querySelector(
            '.driver-popover-description [data-hdv-ir-perfil-cliente]'
        )

        if (!link || link._hdvIrPerfilBound) return

        link._hdvIrPerfilBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            irParaPerfilCliente(tourManager)
        })
    }, 0)
}

const buildFormSteps = (tourManager, { indiceNovoStep = null } = {}) => [
    {
        element: '[data-tour="cliente-nome-fantasia"]',
        ensureReady: () => tourManager.waitForElement(FORM_READY_SELECTOR),
        popover: {
            title: 'Nome Fantasia',
            description: 'É o nome pelo qual o cliente aparece no sistema.',
            side: 'bottom',
            align: 'start',
            onPrevClick: () => {
                if (Number.isInteger(indiceNovoStep)) {
                    tourManager.navigateAndWait('/cliente', '[data-tour="cliente-novo"]', indiceNovoStep)
                        .then(() => tourManager.moveTo(indiceNovoStep))
                        .catch(() => {})
                    return
                }

                tourManager.movePrevious()
            },
        },
    },
    {
        element: '[data-tour="cliente-perfil"]',
        popover: {
            title: 'Perfil',
            description: 'O perfil define o que o cliente poderá ver e fazer no Portal e no aplicativo. Ele precisa existir antes deste cadastro.<br><br>Caso você ainda não tenha cadastrado um perfil, <a href="#" class="hdv-tour-start-link" data-hdv-ir-perfil-cliente>clique aqui</a>.',
            side: 'bottom',
            align: 'start',
        },
        onHighlighted: () => bindIrPerfilClienteLink(tourManager),
    },
    {
        element: '[data-tour="cliente-status"]',
        popover: {
            title: 'Status',
            description: 'Ativo libera o uso do cliente. Bloqueado ou Cancelado restringem o acesso dele ao sistema.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="cliente-opcionais"]',
        popover: {
            title: 'Opcionais',
            description: 'Aqui ficam dados complementares, como e-mail de login do cliente, documentos e setor. Clique em <strong>Próximo</strong> para abrir e ver os campos.',
            side: 'top',
            align: 'start',
            onNextClick: () => {
                openOpcionais()
                setTimeout(() => tourManager.moveNext(), 150)
            },
        },
        onHighlighted: () => openOpcionais(),
    },
    {
        element: '[data-tour="cliente-email-admin"]',
        popover: {
            title: 'E-mail administrador',
            description: 'É o e-mail usado para enviar o convite de acesso ao cliente. Sem ele, o login precisará ser criado manualmente depois.',
            side: 'bottom',
            align: 'start',
        },
        onHighlighted: () => openOpcionais(),
    },
    {
        element: '[data-tour="cliente-razao-social"]',
        popover: {
            title: 'Razão Social',
            description: 'Informe a razão social do cliente, quando houver.',
            side: 'bottom',
            align: 'start',
        },
        onHighlighted: () => openOpcionais(),
    },
    {
        element: '[data-tour="tab-cliente-enderecos"]',
        popover: {
            title: 'Aba Endereços',
            description: 'Esta aba só é liberada depois de salvar o cliente. Nela você cadastra os endereços usados no sistema.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="tab-cliente-contatos"]',
        popover: {
            title: 'Aba Contatos',
            description: 'Também liberada após salvar. Use para cadastrar telefones e e-mails de referência do cliente.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="tab-cliente-modulos"]',
        popover: {
            title: 'Aba Acesso à Módulos',
            description: 'Após salvar, você poderá vincular os módulos contratados para este cliente, quando houver.',
            side: 'bottom',
            align: 'start',
        },
    },
    {
        element: '[data-tour="cliente-salvar"]',
        popover: {
            title: 'Salvar cliente',
            description: 'Preencha os campos necessários e salve. Depois disso, as abas Endereços, Contatos e Acesso à Módulos ficam disponíveis.',
            side: 'top',
            align: 'start',
        },
        onHighlighted: (element) => {
            bindFinishTourOnClick(element, tourManager, 'novo-cliente')
        },
        onDeselected: (element) => {
            unbindFinishTourOnClick(element)
        },
    },
    {
        popover: {
            title: 'Tudo pronto!',
            description: 'Após salvar, edite o cliente novamente e use o ícone de <strong>Ajuda</strong> para o guia das abas liberadas. Na lista de clientes, use <strong>Enviar Convite / Criar Senha</strong> para liberar o login do cliente.',
            onDoneClick: concluirTour(tourManager),
        },
    },
]

const buildNovoClienteTourSteps = (tourManager) => {
    const prefix = [
        {
            popover: {
                title: 'Cadastro de Cliente',
                description: 'Aqui você cadastra quem terá acesso a plataforma e ao aplicativo. O cliente recebe login próprio e fica vinculado a um perfil de permissões, o que é necessário também para criar Monitorados.',
            },
        },
    ]

    if (hasClientesNaLista()) {
        prefix.push(
            {
                element: '[data-tour="cliente-lista"]',
                popover: {
                    title: 'Clientes cadastrados',
                    description: 'Para enviar um convite ou criar a senha de um cliente já cadastrado, marque a caixa de seleção na linha dele.',
                    side: 'top',
                    align: 'start',
                },
                onHighlighted: () => bindHandoffAoEditarCliente(tourManager),
            },
            {
                element: '[data-tour="cliente-convite"]',
                popover: {
                    title: 'Enviar Convite / Criar Senha',
                    description: 'Com um cliente selecionado, este botão é liberado. Use-o para enviar o convite por e-mail ou criar a senha de acesso ao sistema e ao aplicativo.',
                    side: 'bottom',
                    align: 'start',
                },
                onHighlighted: (element) => {
                    bindHandoffAoEditarCliente(tourManager)

                    const onClick = () => {
                        if (!element.classList.contains('hdv-btn-disable')) {
                            tourManager.minimize()
                        }
                    }

                    element.addEventListener('click', onClick)
                    element._hdvTourConviteClick = onClick
                },
                onDeselected: (element) => {
                    if (element?._hdvTourConviteClick) {
                        element.removeEventListener('click', element._hdvTourConviteClick)
                        delete element._hdvTourConviteClick
                    }
                },
            }
        )
    }

    const indiceNovoStep = prefix.length
    const formStartIndex = indiceNovoStep + 1

    prefix.push({
        element: '[data-tour="cliente-novo"]',
        popover: {
            title: 'Novo cliente',
            description: 'Para iniciar um novo cadastro, clique em <strong>Próximo</strong>. Vamos percorrer os dados principais e as abas que são liberadas após salvar.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => {
                unbindHandoffAoEditarCliente()
                tourManager.navigateAndWait('/cliente/novo', FORM_READY_SELECTOR, formStartIndex)
                    .then(() => tourManager.moveTo(formStartIndex))
                    .catch(() => {})
            },
            onPrevClick: () => tourManager.movePrevious(),
        },
        onHighlighted: () => {
            if (window.location.pathname === '/cliente' || window.location.pathname === '/cliente/') {
                bindHandoffAoEditarCliente(tourManager)
            }
        },
    })

    tourManager.setTourCleanup?.(() => unbindHandoffAoEditarCliente())

    return [...prefix, ...buildFormSteps(tourManager, { indiceNovoStep })]
}

export { buildClientePosSalvarTourSteps }
export default buildNovoClienteTourSteps
